import { render, staticRenderFns } from "./WorkHoursCreate.vue?vue&type=template&id=0b3b4b70"
import script from "./WorkHoursCreate.vue?vue&type=script&lang=ts"
export * from "./WorkHoursCreate.vue?vue&type=script&lang=ts"
import style0 from "./WorkHoursCreate.vue?vue&type=style&index=0&id=0b3b4b70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports